// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error-text {
  font-size: 12px;
  line-height: 14px;
  color: var(--color-content-secondary);
}
.error-text--active {
  color: var(--color-error-content-base);
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/shared/common/ui/form-inputs/ErrorText.less"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,iBAAA;EACA,qCAAA;AACF;AACE;EACE,sCAAA;AACJ","sourcesContent":[".error-text {\n  font-size: 12px;\n  line-height: 14px;\n  color: var(--color-content-secondary);\n\n  &--active {\n    color: var(--color-error-content-base);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
